import type * as THREE from 'three';

type PreviewFollowTargets = {
  robotPosition: THREE.Vector3;
  previousOffset: THREE.Vector3;
  cameraPosition: THREE.Vector3;
  cameraTarget: THREE.Vector3;
  groundPosition: THREE.Vector3;
  floorPosition: THREE.Vector3;
  floorTextureOffset: THREE.Vector2;
  floorTextureRepeat: THREE.Vector2;
  floorSize: number;
};

export const followPreviewMovement = ({
  robotPosition,
  previousOffset,
  cameraPosition,
  cameraTarget,
  groundPosition,
  floorPosition,
  floorTextureOffset,
  floorTextureRepeat,
  floorSize,
}: PreviewFollowTargets) => {
  const offsetX = robotPosition.x;
  const offsetY = robotPosition.y;
  const deltaX = offsetX - previousOffset.x;
  const deltaY = offsetY - previousOffset.y;

  cameraPosition.x += deltaX;
  cameraPosition.y += deltaY;
  cameraTarget.x += deltaX;
  cameraTarget.y += deltaY;
  groundPosition.x = offsetX;
  groundPosition.y = offsetY;
  floorPosition.x = offsetX;
  floorPosition.y = offsetY;
  floorTextureOffset.set(
    offsetX * floorTextureRepeat.x / floorSize,
    offsetY * floorTextureRepeat.y / floorSize,
  );
  previousOffset.set(offsetX, offsetY, 0);
};